import { tv } from 'tailwind-variants';

export const textVariants = tv({
  base: [
    'p-2',
    'text-sm',
    'font-semibold',
    'uppercase',
    'leading-[1.125rem]',
    'tracking-[1px]',
    'text-blue-400'
  ]
});

export const paginationButtonVariants = tv({
  extend: textVariants,
  base: [
    'hover:bg-sienna-100/20',
    'hover:text-sienna-400',
    'disabled:pointer-events-none',
    'disabled:text-grey-400',
    'disabled:hover:bg-transparent',
    'aria-disabled:pointer-events-none',
    'aria-disabled:text-grey-400',
    'aria-disabled:hover:bg-transparent',
    'data-[state=active]:text-sienna-400',
    'data-[state=active]:shadow-[0_-3px_0_0_inset]',
    'data-[state=active]:shadow-sienna-400',
    'data-[state=active]:disabled:text-grey-500'
  ]
});
